export const ADD_PAGE = "$$PaginationProvider/ADD_PAGE";
export const DELETE_PAGE = "$$PaginationProvider/DELETE_PAGE";
export const CLEAR_PAGES = "$$PaginationProvider/CLEAR_PAGES";
export const SETUP_PAGINATION = "$$PaginationProvider/SETUP_PAGINATION";
export const MOVE_TO = "$$PaginationProvider/MOVE_TO";
export const MOVE_NEXT = "$$PaginationProvider/MOVE_NEXT";
export const MOVE_BACK = "$$PaginationProvider/MOVE_BACK";
export const MOVE_LAST = "$$PaginationProvider/MOVE_LAST";
export const MOVE_FIRST = "$$PaginationProvider/MOVE_FIRST";
